
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class WhatsAppTemplateVariablesDialog extends Serenity.EntityDialog<WhatsAppTemplateVariablesRow, any> {
        protected getFormKey() { return WhatsAppTemplateVariablesForm.formKey; }
        protected getIdProperty() { return WhatsAppTemplateVariablesRow.idProperty; }
        protected getLocalTextPrefix() { return WhatsAppTemplateVariablesRow.localTextPrefix; }
        protected getNameProperty() { return WhatsAppTemplateVariablesRow.nameProperty; }
        protected getService() { return WhatsAppTemplateVariablesService.baseUrl; }
        protected getDeletePermission() { return WhatsAppTemplateVariablesRow.deletePermission; }
        protected getInsertPermission() { return WhatsAppTemplateVariablesRow.insertPermission; }
        protected getUpdatePermission() { return WhatsAppTemplateVariablesRow.updatePermission; }

        protected form = new WhatsAppTemplateVariablesForm(this.idPrefix);

    }
}